'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Search = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Search = require('./Search');

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Search = _Search2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-search')(_Search2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/Search/index.js
 ** module id = 615
 ** module chunks = 1
 **/